import React, { Component , useEffect, useState} from 'react';
import Copyright from '../componentes/copyright';
import Principal from '../componentes/principal';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import {withRouter} from 'react-router-dom';
import { Container } from '@material-ui/core';
import firebase from "firebase/app";
import 'firebase/firestore';
import {authConfig} from '../auth/config';
import Carduser from './cardUser';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';

const classes = makeStyles((theme) => ({
   paper: {
     marginTop: theme.spacing(8),
     display: 'flex',
     flexGrow: 1,
     flexDirection: 'column',
     alignItems: 'center',
   },
   title: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    menuButton: {
      marginRight: theme.spacing(2),
      marginTop: theme.spacing(20),
    },
    submit: {
      margin: theme.spacing(2, 2, 2),
  
     
  
    },
}));

document.title = 'Frota UFSM'
document.logo=''


var codunidadetransporte='';
var codcentroadm='';
var codunidadedepartamento='';

var depnome='';
var stuser="1";
var listausuarios=[];
var ut;
export const  Usuarios = withRouter(({history}) => {
  //var ut='0';
  var listacentros=[];
  var listadepartamentos=[];
   
  const [state, setState] = useState([]);
  const [utipo,setautipo]=React.useState("0");
  const [dado, setadado]=React.useState([]);

  ///********************************************** */
  React.useEffect(() => {
    pegauser()
    async function pegauser(){
      const user = authConfig.auth().currentUser;
       var db = firebase.firestore();
       var userref =  db.collection("usuarios").doc(user.uid);         
       console.log("esta aqui 001");
     await  userref.get().then((doc) => {       
         if (doc.exists) {
           console.log("pegou o user:", doc.data());
           ut = doc.data().usertipo;
           //setautipo(ut);
           var data= doc.data();
           //setadado(data);
           setautipo(ut);
           console.log("pegou o user:", ut);
          
           console.log("Document data pegoulaaaaaaa:", utipo);

           if(ut>1){
            //**************
            if ((ut==2)||(ut==3)) {
             console.log("Document data pegouppqpq:", ut);
             //setcodcentro(doc.data().codcentroadm);
             codunidadedepartamento = doc.data().codunidadedepartamento;
             pegalista2(ut);
             
            } else {
             if ((ut==4)||(ut==5)) {
               console.log("Document data 55555pegouppqpq:", ut);
               var codcadm;
               codcentroadm= doc.data().codcentroadm;
               console.log("Document data pegouppqpqaquiiiii:", codcadm);
               //console.log("Document data pegouppqpqaquiiiii:", dado);
               pegalista2(ut);
               
              //console.log("Document data listadepssss:", listadepartamentos);
             // pegalista();
              }else{
               if ((ut==6)||(ut==7)) {
                 console.log("entrou no 7 e vai pegar centros:");
                 codunidadetransporte = doc.data().codunidadetransporte;
                //pegacodcentros(codunidadetransporte,ut);
                 pegalista2(ut);
                }else{
                  if((ut==8)||(ut==9)||(ut==10)){
                    console.log("entrou no 8 9 10 e vai pegar centros:");
                   codunidadetransporte = doc.data().codunidadetransporte;
                   pegalista2(ut);
                  }
                }
              }
              
            }
            
      
           }

         }else{
           alert('Não encontramos o seu cadastro')
         }
        
        }).catch(function(error) {
        alert("Erro ao localizar o seu cadastro aqui ", error.message);
        })
  }

 /* async function pegacodcentros(cod,ut1){
    console.log("entrou no centros:", cod);
    var db = firebase.firestore();
    var query = await db.collection("centroadm").where("codunidadetransporte","==", cod).orderBy("nomecentroadm").get()
    .then(snapshot => {
      if (snapshot.empty) {
         // alert('No matching documents.');
          pegalista(ut1);
      }
       
      snapshot.forEach(doc => {
          
        listacentros.push({id: doc.id, nomecentroadm: doc.data().nomecentroadm
        });
        console.log("pegou centros ", listacentros );
  })
})
    
    
    
  .catch(error => {
      console.log('Não encontramos veículos cadastrados', error);
  });
  console.log("pegou lista centros ", listacentros );
 listacentros.map(item=>{
   
 pegacoddepartamentos(item.id, ut1);

  })
  
}

async function pegacoddepartamentos(cod, ut2){
  console.log("entrou pegar departamentos:", cod);
  
  var db = firebase.firestore();
var departamentoRef = db.collection("departamentos").where('codcentroadm','==', cod).orderBy("depnome").get()
    .then(snapshot => {
        if (snapshot.empty) {
           // alert('No matching documents.');
           pegalista(ut2);
        }else{
         
        snapshot.forEach(doc => {
            
          listadepartamentos.push({id: doc.id, depnome: doc.data().depnome});
        });
        pegalista(ut2);
        console.log('imprimindo lista deps', listadepartamentos);
      }
    })
    .catch(error => {
        console.log('Error getting documents', error);
    })
  }

  async function pegalista(ut3) {      
    console.log("user tipo poxa  puta merda pegalista", ut3);    
    console.log("user tipo poxa  puta merda pegalista", codunidadedepartamento);    
    if((ut3==2)||(ut3==3)) {
      
      var db = firebase.firestore();
      var nomeunidade;
      var query0 = db.collection("departamentos").doc(codunidadedepartamento);
      
      await  query0.get().then((doc) => {       
        if (doc.exists) {
        nomeunidade=doc.data().depnome;
        }
      })
        .catch(error => {
          console.log('Não encontramos o departamento', error);
      });

      var query = await db.collection("usuarios").where("usertipo","in", ["1", "2"]).where("codunidadedepartamento","==", codunidadedepartamento).orderBy("nome").get()
      .then(function(querySnapshot) {
      
       querySnapshot.forEach(function(doc) {
         var listausers=[];
           listausers.push({id: doc.id, nome: doc.data().nome,email:doc.data().email,
             siape:doc.data().siape, telefone: doc.data().telefone, status: doc.data().userstatus, deps: nomeunidade,
           usertipo: doc.data().usertipo, campi: doc.data().campi, codunidadedepartamento: doc.data().codunidadedepartamento});
         console.log("veiculos pqp ", state );
        setState (currentArray => [...currentArray, listausers]);
        

       });
      
     })
    .catch(error => {
        console.log('Não encontramos veículos cadastrados', error);
    });
    
    }else {
          if((ut3==4)||(ut3==5)) {
          console.log("user tipo poxa puta merda 4 ou 5", ut);
          console.log("user tipo poxa puta merda qlq5", listadepartamentos);
          console.log("user tipo poxa puta merda 4 ou 5", codcentroadm);
          ///
          var db = firebase.firestore();

          var nomecentroadm;
      var query0 = db.collection("centroadm").doc(codcentroadm);
      
      await  query0.get().then((doc) => {       
        if (doc.exists) {
        nomecentroadm=doc.data().nomecentroadm;
        }
      })
        .catch(error => {
          console.log('Não encontramos o Nucleo Amdminisrativo', error);
      });
      var query = await db.collection("usuarios").where("usertipo", "<=", "4").where("codcentroadm","==", codcentroadm).orderBy("nome").get()
      .then(function(querySnapshot) {
      
       querySnapshot.forEach(function(doc) {
        var listausers=[];
        console.log("vdentro query  ", listausers );
          listausers.push({id: doc.id, nome: doc.data().nome,email:doc.data().email, deps: nomecentroadm,
            siape:doc.data().siape, telefone: doc.data().telefone, status: doc.data().userstatus,
          usertipo: doc.data().usertipo, campi: doc.data().campi, codcentroadm: doc.data().codcentroadm});
        console.log("veiculos pqp ", listausers );
        setState (currentArray => [...currentArray,listausers]);
       

   
            });
            console.log("veiculos state poxa ", state );
          })
         .catch(error => {
             console.log('Não encontramos veículos cadastrados', error);
         });
         console.log("antes do no map", listadepartamentos )
         listadepartamentos.map(item=>{
           var id='';
           id=item.id;
          console.log("entrou no map", item)
          var db = firebase.firestore();
           var query = db.collection("usuarios").where("codunidadedepartamento","==", item.id).get()
           .then(function(querySnapshot) {
      
            querySnapshot.forEach(function(doc) {
              var listausers=[];
                listausers.push({id: doc.id, nome: doc.data().nome, deps:item.depnome, email:doc.data().email,
                  siape:doc.data().siape, telefone: doc.data().telefone, status: doc.data().userstatus, 
                  usertipo: doc.data().usertipo, campi: doc.data().campi, codunidadedepartamento: doc.data().codunidadedepartamento});
              console.log("veiculos pqp ", state );
             setState (currentArray => [...currentArray, listausers]);
             
   
            });
           
          })
         .catch(error => {
             console.log('Não encontramos veículos cadastrados', error);
         });
         });
         
         }else {
          console.log("valor ut dentro deo egalista", ut);
          console.log("valor utipo3 dentro deo egalista", ut3);

          if((ut3==6)||(ut3==7)) {
            setState([]);
            console.log("user tipo poxa", codunidadetransporte);
            var db = firebase.firestore();
            var nomeunidadetransporte;
            var query0 = db.collection("unidaderansporte").doc(codunidadetransporte);
      
            await  query0.get().then((doc) => {       
              if (doc.exists) {
              nomeunidadetransporte=doc.data().nomeunidadetransporte;
              }
            })
              .catch(error => {
                console.log('Não encontramos o departamento', error);
            });

            var query = db.collection("usuarios").where("usertipo", "in", ['1','6']).where("codunidadetransporte","==", codunidadetransporte).get()
            .then(function(querySnapshot) {
       
             querySnapshot.forEach(function(doc) {
               var listausers=[];
                 listausers.push({id: doc.id, nome: doc.data().nome,email:doc.data().email,
                   siape:doc.data().siape, telefone: doc.data().telefone, status: doc.data().userstatus, deps:nomeunidadetransporte,
                 usertipo: doc.data().usertipo, campi: doc.data().campi, codunidadetransporte: doc.data().codunidadetransporte});
               console.log("veiculos pqp ", state );
              setState (currentArray => [...currentArray, listausers]);
              
    
             });
            
           })
          .catch(error => {
              console.log('Não encontramos veículos cadastrados', error);
          });

          listacentros.map(item=>{
            //console.log('Não encontramos porcariados', item.id);
           var db = firebase.firestore();
            var query = db.collection("usuarios").where("codcentroadm","==", item.id).orderBy("nome").get()
            .then(function(querySnapshot) {
              
             querySnapshot.forEach(function(doc) {
               var listausers=[];
                 listausers.push({id: doc.id, nome: doc.data().nome, deps:item.nomecentroadm,email:doc.data().email,
                   siape:doc.data().siape, telefone: doc.data().telefone, status: doc.data().userstatus, 
                 usertipo: doc.data().usertipo, campi: doc.data().campi, codcentroadm: doc.data().codcentroadm});
               console.log("veiculos pqp ", state );
              setState (currentArray => [...currentArray, listausers]);
              
    
             });
            
           })
          .catch(error => {
              console.log('Não encontramos veículos cadastrados', error);
          });
          });

          listadepartamentos.map(item=>{
            var db = firebase.firestore();
            var query = db.collection("usuarios").where("codunidadedepartamento","==", item.id).orderBy("nome").get()
            .then(function(querySnapshot) {
       
             querySnapshot.forEach(function(doc) {
               var listausers=[];
                 listausers.push({id: doc.id, nome: doc.data().nome, deps:item.depnome,email:doc.data().email,
                   siape:doc.data().siape, telefone: doc.data().telefone, status: doc.data().userstatus,
                 usertipo: doc.data().usertipo, campi: doc.data().campi, codunidadedepartamento: doc.data().codunidadedepartamento});
               console.log("veiculos pqp ", state );
              setState (currentArray => [...currentArray, listausers]);
              
    
             });
            
           })
          .catch(error => {
              console.log('Não encontramos veículos cadastrados', error);
          });
          })
          
          }else {
            if((ut3==8)||(ut3==9)||(ut3==10)) {

              var db = firebase.firestore();
            var departamentoRef = await db.collection("departamentos").orderBy("depnome").get()
                .then(snapshot => {
                    if (snapshot.empty) {
                        alert('No matching documents.');
                      
                    }
                    
                    snapshot.forEach(doc => {
                        
                      listadepartamentos.push({id: doc.id, depnome: doc.data().depnome});
                    });
                    console.log('imprimindo lista deps', listadepartamentos);
                })
                .catch(error => {
                    console.log('Error getting documents', error);
                })

                listadepartamentos.map(item=>{
                  var db1 = firebase.firestore();
                  var query = db1.collection("usuarios").where("codunidadedepartamento","==", item.id).orderBy("nome").
                  get().then(function(querySnapshot) {
             
                   querySnapshot.forEach(function(doc) {
                     var listausers=[];
                       listausers.push({id: doc.id, nome: doc.data().nome, deps:item.depnome,email:doc.data().email,
                         siape:doc.data().siape, telefone: doc.data().telefone, status: doc.data().userstatus,
                       usertipo: doc.data().usertipo, campi: doc.data().campi, codunidadedepartamento: doc.data().codunidadedepartamento});
                     console.log("veiculos pqp ", state );
                    setState (currentArray => [...currentArray, listausers]);
                    
          
                   });
                  
                 })
                .catch(error => {
                    console.log('Não encontramos veículos cadastrados', error);
                });
                })


                
            var departamentoRef1 = await db.collection("centroadm").orderBy("nomecentroadm").get()
                .then(snapshot => {
                    if (snapshot.empty) {
                        alert('No matching documents.');
                      
                    }
                    
                    snapshot.forEach(doc => {
                        
                      listacentros.push({id: doc.id, nomecentroadm: doc.data().nomecentroadm});
                    });
                    console.log('imprimindo lista deps', listacentros);
                })
                .catch(error => {
                    console.log('Error getting documents', error);
                })

                listacentros.map(item=>{
                  var db = firebase.firestore();
                  var query = db.collection("usuarios").where("codcentroadm","==", item.id).orderBy("nome").get()
                  .then(function(querySnapshot) {
             
                   querySnapshot.forEach(function(doc) {
                     var listausers=[];
                       listausers.push({id: doc.id, nome: doc.data().nome, deps:item.nomecentroadm,email:doc.data().email,
                         siape:doc.data().siape, telefone: doc.data().telefone, status: doc.data().userstatus,
                       usertipo: doc.data().usertipo, campi: doc.data().campi, codcentroadm: doc.data().codcentroadm});
                     console.log("veiculos pqp ", state );
                    setState (currentArray => [...currentArray, listausers]);
                    
          
                   });
                  
                 })
                .catch(error => {
                    console.log('Não encontramos veículos cadastrados', error);
                });
                })
                var listaunidadest=[];
                var departamentoRef2 = await db.collection("unidadetransporte").orderBy("nomeunidadetransporte").get()
                .then(snapshot => {
                    if (snapshot.empty) {
                        alert('No matching documents.');
                      
                    }
                    
                    snapshot.forEach(doc => {
                        
                      listaunidadest.push({id: doc.id, nomeunidadetransporte: doc.data().nomeunidadetransporte});
                    });
                    console.log('imprimindo lista deps', listaunidadest);
                })
                .catch(error => {
                    console.log('Error getting documents', error);
                })

                listaunidadest.map(item=>{
                  var db = firebase.firestore();
                  var query = db.collection("usuarios").where("usertipo",'in',['1','6','7','8']).
                  where("codunidadetransporte","==", item.id).orderBy("nome").get()
                  .then(function(querySnapshot) {
             
                   querySnapshot.forEach(function(doc) {
                     var listausers=[];
                       listausers.push({id: doc.id, nome: doc.data().nome, deps:item.nomeunidadetransporte,email:doc.data().email,
                         siape:doc.data().siape, telefone: doc.data().telefone, status: doc.data().userstatus,
                       usertipo: doc.data().usertipo, campi: doc.data().campi, codunidadetransporte: doc.data().codunidadetransporte});
                     console.log("veiculos pqp ", state );
                    setState (currentArray => [...currentArray, listausers]);
                    
          
                   });
                  
                 })
                .catch(error => {
                    console.log('Não encontramos veículos cadastrados', error);
                });
                })
              
              
            }
         
         
         
        }
         }}
   
  }


 */
  
},[0])

 //************************************ */

 async function pegalista2(ut3) {      
  console.log("user tipo poxa  puta merda pegalista", ut3);    
  console.log("user tipo poxa  puta merda pegalista", codunidadedepartamento);    
  if((ut3==2)||(ut3==3)) {
    
    var db = firebase.firestore();
   

    var query = await db.collection("usuarios").where("usertipo","in", ["1", "2"]).where("codunidadedepartamento","==", codunidadedepartamento).orderBy("nome").get()
    .then(function(querySnapshot) {
    
     querySnapshot.forEach(function(doc) {
       var listausers=[];
         listausers.push({id: doc.id, nome: doc.data().nome,email:doc.data().email,
           siape:doc.data().siape, telefone: doc.data().telefone, status: doc.data().userstatus, 
         usertipo: doc.data().usertipo, campi: doc.data().campi, codunidadedepartamento: doc.data().codunidadedepartamento});
       console.log("veiculos pqp ", state );
      setState (currentArray => [...currentArray, listausers]);
      

     });
    
   })
  .catch(error => {
      console.log('Não encontramos veículos cadastrados', error);
  });
  
  }else {
        if((ut3==4)||(ut3==5)) {
        console.log("user tipo poxa puta merda 4 ou 5", ut);
        console.log("user tipo poxa puta merda qlq5", listadepartamentos);
        console.log("user tipo poxa puta merda 4 ou 5", codcentroadm);
        ///
        var db = firebase.firestore();

        
    var query = await db.collection("usuarios").where("usertipo", "in", ["1","2","3","4"]).where("codcentroadm","==", codcentroadm).orderBy("nome").get()
    .then(function(querySnapshot) {
    
     querySnapshot.forEach(function(doc) {
      var listausers=[];
      console.log("vdentro query  ", listausers );
        listausers.push({id: doc.id, nome: doc.data().nome,email:doc.data().email, 
          siape:doc.data().siape, telefone: doc.data().telefone, status: doc.data().userstatus,
        usertipo: doc.data().usertipo, campi: doc.data().campi, codcentroadm: doc.data().codcentroadm});
      console.log("veiculos pqp ", listausers );
      setState (currentArray => [...currentArray,listausers]);
     

 
          });
          console.log("veiculos state poxa ", state );
        })
       .catch(error => {
           console.log('Não encontramos veículos cadastrados', error);
       });
       console.log("antes do no map", listadepartamentos )
       
        var db = firebase.firestore();
         var query = db.collection("usuarios").where("vinculocodcentroadm","==", codcentroadm).orderBy("nome").get()
         .then(function(querySnapshot) {
    
          querySnapshot.forEach(function(doc) {
            var listausers=[];
              listausers.push({id: doc.id, nome: doc.data().nome, email:doc.data().email,
                siape:doc.data().siape, telefone: doc.data().telefone, status: doc.data().userstatus, 
                usertipo: doc.data().usertipo, campi: doc.data().campi, codunidadedepartamento: doc.data().codunidadedepartamento});
            console.log("veiculos pqp ", state );
           setState (currentArray => [...currentArray, listausers]);
           
 
          });
         
        })
       .catch(error => {
           console.log('Não encontramos veículos cadastrados', error);
       });
      
       
       }else {
        console.log("valor ut dentro deo egalista", ut);
        console.log("valor utipo3 dentro deo egalista", ut3);

        if((ut3==6)||(ut3==7)) {
          setState([]);
          console.log("user tipo poxa", codunidadetransporte);
          var db = firebase.firestore();
          

          var query = db.collection("usuarios").where("usertipo", "in", ['1','6']).where("codunidadetransporte","==", codunidadetransporte).orderBy("nome").get()
          .then(function(querySnapshot) {
     
           querySnapshot.forEach(function(doc) {
             var listausers=[];
               listausers.push({id: doc.id, nome: doc.data().nome,email:doc.data().email,
                 siape:doc.data().siape, telefone: doc.data().telefone, status: doc.data().userstatus, 
               usertipo: doc.data().usertipo, campi: doc.data().campi, codunidadetransporte: doc.data().codunidadetransporte});
             console.log("veiculos pqp ", state );
            setState (currentArray => [...currentArray, listausers]);
            
  
           });
          
         })
        .catch(error => {
            console.log('Não encontramos veículos cadastrados', error);
        });

       
         var db = firebase.firestore();
          var query = db.collection("usuarios").where("vinculocodunidadetransporte","==", codunidadetransporte).orderBy("nome").get()
          .then(function(querySnapshot) {
            
           querySnapshot.forEach(function(doc) {
             var listausers=[];
               listausers.push({id: doc.id, nome: doc.data().nome,email:doc.data().email,
                 siape:doc.data().siape, telefone: doc.data().telefone, status: doc.data().userstatus, 
               usertipo: doc.data().usertipo, campi: doc.data().campi,codunidadedepartamento: doc.data().codunidadedepartamento, codcentroadm: doc.data().codcentroadm});
             console.log("veiculos pqp ", state );
            setState (currentArray => [...currentArray, listausers]);
            
  
           });
          
         })
        .catch(error => {
            console.log('Não encontramos veículos cadastrados', error);
        });
       

       
        
        }else {
          if((ut3==8)||(ut3==9)||(ut3==10)) {

            
                var db1 = firebase.firestore();
                var query = db1.collection("usuarios").where("usertipo", "<=", "9").orderBy("nome").
                get().then(function(querySnapshot) {
           
                 querySnapshot.forEach(function(doc) {
                   var listausers=[];
                     listausers.push({id: doc.id, nome: doc.data().nome,email:doc.data().email,
                       siape:doc.data().siape, telefone: doc.data().telefone, status: doc.data().userstatus,
                     usertipo: doc.data().usertipo, campi: doc.data().campi,codunidadetransporte: doc.data().codunidadetransporte, codunidadedepartamento: doc.data().codunidadedepartamento,codcentroadm: doc.data().codcentroadm});
                   console.log("veiculos pqp ", state );
                  setState (currentArray => [...currentArray, listausers]);
                  
        
                 });
                
               })
              .catch(error => {
                  console.log('Não encontramos veículos cadastrados', error);
              });
              


              
         
            
          }
       
       
       
      }
       }}
 
}

//****************************** */
//************************************ */

async function pegalistafiltro(filtro) {   
  setState([])   
  //console.log("user tipo poxa  puta merda pegalista", ut3);    
  console.log("user tipo poxa  puta merda pegalista", codunidadedepartamento);    
  if((ut==2)||(ut==3)) {
    
    var db = firebase.firestore();
   

    var query = await db.collection("usuarios").where("usertipo","in", ["1", "2"]).where("codunidadedepartamento","==", codunidadedepartamento).where("userstatus","==",filtro).orderBy("nome").get()
    .then(function(querySnapshot) {
    
     querySnapshot.forEach(function(doc) {
       var listausers=[];
         listausers.push({id: doc.id, nome: doc.data().nome,email:doc.data().email,
           siape:doc.data().siape, telefone: doc.data().telefone, status: doc.data().userstatus, 
         usertipo: doc.data().usertipo, campi: doc.data().campi, codunidadedepartamento: doc.data().codunidadedepartamento});
       console.log("veiculos pqp ", state );
      setState (currentArray => [...currentArray, listausers]);
      

     });
    
   })
  .catch(error => {
      console.log('Não encontramos veículos cadastrados', error);
  });
  
  }else {
        if((ut==4)||(ut==5)) {
        
        var db = firebase.firestore();

        
    var query = await db.collection("usuarios").where("usertipo", "in", ["1","2","3","4"]).where("codcentroadm","==", codcentroadm).where("userstatus","==",filtro).orderBy("nome").get()
    .then(function(querySnapshot) {
    
     querySnapshot.forEach(function(doc) {
      var listausers=[];
      console.log("vdentro query  ", listausers );
        listausers.push({id: doc.id, nome: doc.data().nome,email:doc.data().email, 
          siape:doc.data().siape, telefone: doc.data().telefone, status: doc.data().userstatus,
        usertipo: doc.data().usertipo, campi: doc.data().campi, codcentroadm: doc.data().codcentroadm});
      console.log("veiculos pqp ", listausers );
      setState (currentArray => [...currentArray,listausers]);
     

 
          });
          console.log("veiculos state poxa ", state );
        })
       .catch(error => {
           console.log('Não encontramos veículos cadastrados', error);
       });
       console.log("antes do no map", listadepartamentos )
       
        var db = firebase.firestore();
         var query = db.collection("usuarios").where("vinculocodcentroadm","==", codcentroadm).where("userstatus","==",filtro).orderBy("nome").get()
         .then(function(querySnapshot) {
    
          querySnapshot.forEach(function(doc) {
            var listausers=[];
              listausers.push({id: doc.id, nome: doc.data().nome, email:doc.data().email,
                siape:doc.data().siape, telefone: doc.data().telefone, status: doc.data().userstatus, 
                usertipo: doc.data().usertipo, campi: doc.data().campi, codunidadedepartamento: doc.data().codunidadedepartamento});
            console.log("veiculos pqp ", state );
           setState (currentArray => [...currentArray, listausers]);
           
 
          });
         
        })
       .catch(error => {
           console.log('Não encontramos veículos cadastrados', error);
       });
      
       
       }else {
        
        if((ut==6)||(ut==7)) {
          setState([]);
          console.log("user tipo poxa", codunidadetransporte);
          var db = firebase.firestore();
          

          var query = db.collection("usuarios").where("usertipo", "in", ['1','6']).where("codunidadetransporte","==", codunidadetransporte).where("userstatus","==",filtro).orderBy("nome").get()
          .then(function(querySnapshot) {
     
           querySnapshot.forEach(function(doc) {
             var listausers=[];
               listausers.push({id: doc.id, nome: doc.data().nome,email:doc.data().email,
                 siape:doc.data().siape, telefone: doc.data().telefone, status: doc.data().userstatus, 
               usertipo: doc.data().usertipo, campi: doc.data().campi, codunidadetransporte: doc.data().codunidadetransporte});
             console.log("veiculos pqp ", state );
            setState (currentArray => [...currentArray, listausers]);
            
  
           });
          
         })
        .catch(error => {
            console.log('Não encontramos veículos cadastrados', error);
        });

       
         var db = firebase.firestore();
          var query = db.collection("usuarios").where("vinculocodunidadetransporte","==", codunidadetransporte).where("userstatus","==",filtro).orderBy("nome").get()
          .then(function(querySnapshot) {
            
           querySnapshot.forEach(function(doc) {
             var listausers=[];
               listausers.push({id: doc.id, nome: doc.data().nome,email:doc.data().email,
                 siape:doc.data().siape, telefone: doc.data().telefone, status: doc.data().userstatus, 
               usertipo: doc.data().usertipo, campi: doc.data().campi,codunidadedepartamento: doc.data().codunidadedepartamento, codcentroadm: doc.data().codcentroadm});
             console.log("veiculos pqp ", state );
            setState (currentArray => [...currentArray, listausers]);
            
  
           });
          
         })
        .catch(error => {
            console.log('Não encontramos veículos cadastrados', error);
        });
       

       
        
        }else {
          if((ut==8)||(ut==9)||(ut==10)) {

            
                var db1 = firebase.firestore();
                var query = db1.collection("usuarios").where("usertipo", "<=", "9").where("userstatus","==",filtro).orderBy("nome").
                get().then(function(querySnapshot) {
           
                 querySnapshot.forEach(function(doc) {
                   var listausers=[];
                     listausers.push({id: doc.id, nome: doc.data().nome,email:doc.data().email,
                       siape:doc.data().siape, telefone: doc.data().telefone, status: doc.data().userstatus,
                     usertipo: doc.data().usertipo, campi: doc.data().campi,codunidadetransporte: doc.data().codunidadetransporte, codunidadedepartamento: doc.data().codunidadedepartamento,codcentroadm: doc.data().codcentroadm});
                   console.log("veiculos pqp ", state );
                  setState (currentArray => [...currentArray, listausers]);
                  
        
                 });
                
               })
              .catch(error => {
                  console.log('Não encontramos veículos cadastrados', error);
              });
              


              
         
            
          }
       
       
       
      }
       }}
 
}

//****************************** */
  //************************************* */

  const handleChangeman=(event)=>{
    var v = event.target.value;
    //alert(v)
    
    stuser=v;
    if(v==1){
      pegalista2(ut)
    }else{
      if (v==2) {
        pegalistafiltro(true)
      } else {
        if (v==3) {
          pegalistafiltro(false)
          
        }
        
      }
    }
  }
 
return(
 
<Container >
<CssBaseline />
      
      <div id="cabeça" >
      <Principal/>
      
      
      </div>
      
      <Typography className={classes.title} variant="h5" noWrap align="center">
            Usuários
          </Typography>
          <Container align='center'>
        <Grid container align="center">
        <Grid item xs>
          <FormControl component="fieldset">
      
      <RadioGroup row  aria-label="gender" name="gender1" value={stuser} onChange={handleChangeman}>
        <FormControlLabel value="1" control={<Radio />} label="Todos" />
         <FormControlLabel value="2" control={<Radio />} label="Ativos" />
         <FormControlLabel value="3" control={<Radio />} label="Inativos" />
        </RadioGroup>
    </FormControl>
    </Grid>
    </Grid>
    </Container>
      <div id="corpo"   align="center" className={classes.paper} >

         <div id="corpoveiculo">
           <Container maxWidth="xs">
            
              {console.log('tamanho da lista=> ', state)}
             {state.map(item=>(
               
              <Carduser props={item} id={item.id} key={item.id} />
               
             ))}

             </Container>
           </div>
          
          
      </div>
       
  
       <Box mt={3}>
          <Copyright/>
       </Box>
   
   
   </Container>
)

}

)
 
export default Usuarios;
